import React from "react";
import { CreateGameBox } from "../../containers";

export const CreateGamePage = () => {
  return (
    <div>
      <CreateGameBox />
    </div>
  );
};
